const TEMPLATE_CATALOG_CACHE_KEY = 'mirrorx_template_catalog_cache_v1';

function normalizeTemplateList(value) {
  if (!Array.isArray(value)) return [];
  return value.filter((item) => item && typeof item === 'object');
}

export function readTemplateCatalogCache() {
  try {
    const raw = globalThis.localStorage?.getItem(TEMPLATE_CATALOG_CACHE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const templates = normalizeTemplateList(parsed?.templates);
    if (!templates.length) return null;

    return {
      templates,
      cachedAt: String(parsed?.cachedAt || ''),
      platformUpdatedAt: String(parsed?.platformUpdatedAt || ''),
    };
  } catch {
    return null;
  }
}

export function writeTemplateCatalogCache(templates, { platformUpdatedAt = '' } = {}) {
  const normalized = normalizeTemplateList(templates);
  if (!normalized.length) return null;

  const payload = {
    templates: normalized,
    cachedAt: new Date().toISOString(),
    platformUpdatedAt: String(platformUpdatedAt || ''),
  };

  try {
    globalThis.localStorage?.setItem(
      TEMPLATE_CATALOG_CACHE_KEY,
      JSON.stringify(payload)
    );
  } catch {
    // Ignore storage write failures (private mode / quota)
  }

  return payload;
}

export function clearTemplateCatalogCache() {
  try {
    globalThis.localStorage?.removeItem(TEMPLATE_CATALOG_CACHE_KEY);
  } catch {
    // Ignore storage failures.
  }
}
